export enum TextureSizeSettingId {
  XS = 32,
  SM = 128,
  MD = 256,
  LG = 512,
  XL = 1024,
}